<div *ngIf="description" class="pb-4 font-md">
  {{ description }}
</div>

<form [formGroup]="deliveryForm" class="mb-5 mail-delivery-to-door-form">
  <div class="row">
    <div class="col-6 col-lg-5 col-xl-4">
      <div class="form-group form-group-xl">
        <label class="d-block" [translate]="'common.postNumber'"></label>

        <ui-input-loader-wrap [loading]="postNumBusy">
          <input class="form-control"
                 type="tel"
                 [placeholder]="('common.postNumberPlaceholder_' + countryCode) | translate"
                 [inputMaskArgs]="{countryCode: countryCode}"
                 [inputMask]="'postNumber'"
                 [formControlName]="'deliveryPostNumber'">
        </ui-input-loader-wrap>
      </div>
    </div>

    <div class="col-6 col-lg-7 col-xl-8">
      <div class="form-group form-group-xl">
        <label class="d-block" [translate]="'common.postalArea'"></label>

        <input class="form-control"
               *ngIf="canContinueDelivery"
               [disabled]="true"
               [placeholder]="'common.postalArea' | translate"
               [formControlName]="'deliveryCity'">

        <ng-container *ngIf="!canContinueDelivery">
          <div class="disabled-input-div">
            {{ reserveCityName || ('common.notFound' | translate) }}
          </div>

          <div class="text-danger not-available-msg mt-lg-2"
               [translate]="'orderProcess.delivery.deliveryForms.notAvailable'">
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isCityValid">
    <div class="form-group form-group-xl">
      <label [translate]="'common.delivery.deliveryAddress'"></label>

      <input class="form-control"
             [placeholder]="'orderProcess.delivery.deliveryForms.deliveryAddressPlaceholder' | translate"
             [formControlName]="'deliveryAddress'">
    </div>

    <div class="form-group form-group-xl">
      <label [translate]="'orderProcess.delivery.deliveryForms.recipientName'"></label>

      <input class="form-control"
             [maxlength]="'128'"
             [placeholder]="'common.name' | translate"
             [formControlName]="'deliveryUserName'">
    </div>

    <div class="confirm-btn-wrap mt-3">
      <button class="btn {{nextBtnView}} delivery-confirm-btn"
              [disabled]="deliveryForm.invalid"
              (click)="confirm()">
        <span [translate]="nextBtnTextKey"></span>
      </button>
    </div>
  </ng-container>
</form>
